import hero from "./assets/hero.jpg"
import thumbnailImage from "./assets/piyum_intvw.jpg"
import tmoBody from "./tmoBody"

export const tmoData = {
    title: "Human Centered Design Approach for T-mobile Late Payment Problem",
    heroImage: thumbnailImage,
    thumbnailImage:thumbnailImage,
    body: tmoBody,
}